export const KNOWLEDGE_BASE_URL = {
  ALLOW_ACTIVITIES:
    'https://knowledge-base.yieldbird.com/prebid-stack/prebid-advanced-configuration#block-20061213c49b808eabdae846fceb8e69',
  AUCTION_DELAY: 'https://knowledge-base.yieldbird.com/prebid-stack/timeouts',
} as const
